export function isMobile() {
    var isMobile = /iPhone|iPad|iPod|Android|playbook|silk/i.test(navigator.userAgent);
    if (isMobile) {
        return false;
    } else {
        return true;
    }
}
